import LZString from 'lz-string';

const PRESET_PREFIX = 'cdt-vis:preset:';
// Bump when DEFAULT_CONFIG shape/semantics change, so old URL hashes are ignored.
const CONFIG_VERSION = 4;

export function toUrl(cfg) {
  const payload = { v: CONFIG_VERSION, cfg };
  const s = LZString.compressToEncodedURIComponent(JSON.stringify(payload));
  return '#c=' + s;
}
export function fromUrl() {
  const m = /#c=([^&]+)/.exec(location.hash);
  if (!m) return null;
  try {
    const raw = LZString.decompressFromEncodedURIComponent(m[1]);
    const parsed = JSON.parse(raw);
    // Legacy (unversioned) blobs: ignore so users don't get stuck on old defaults.
    if (!parsed || typeof parsed !== 'object' || parsed.v !== CONFIG_VERSION) return null;
    return parsed.cfg;
  } catch { return null; }
}
export function writeUrl(cfg) {
  history.replaceState(null, '', toUrl(cfg));
}

export function savePreset(name, cfg) {
  localStorage.setItem(PRESET_PREFIX + name, JSON.stringify(cfg));
}
export function loadPreset(name) {
  const v = localStorage.getItem(PRESET_PREFIX + name);
  return v ? JSON.parse(v) : null;
}
export function listPresets() {
  const out = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(PRESET_PREFIX)) out.push(k.slice(PRESET_PREFIX.length));
  }
  return out;
}

export function exportJson(cfg, extras = {}) {
  const payload = { kind: 'cdt-vis-export', ts: new Date().toISOString(), cfg, ...extras };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = `cdt-vis-${Date.now()}.json`;
  document.body.appendChild(a); a.click();
  a.remove(); URL.revokeObjectURL(url);
}

export function importJson(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      try { resolve(JSON.parse(r.result)); } catch (e) { reject(e); }
    };
    r.onerror = reject;
    r.readAsText(file);
  });
}
